import summaryStore from "@/store/summary.store";
import summaryChapterStore from "@/store/summaryChapter.store";
import summarySpeakerStore from "@/store/summarySpeaker.store";
import Card from "./sections/Card";
import Chapter from "./sections/Chapter";
import SpeakerSummary from "./sections/SpeakerSummary";
import MeetingContent from "./sections/MeetingContent";
import MeetingSummary from "./sections/MeetingSummary";
import SummarySkeleton from "./sections/SummarySkeleton";
import SummaryEmpty from "../SummaryEmpty";
import Todo from "./sections/Todo";
import VerticalAnchorList, {
  VerticalAnchorListRef,
} from "@/component/VerticalAnchorList";
import VerticalAnchorItem from "@/component/VerticalAnchorList/VerticalAnchorItem";
import { useRef, useState } from "react";
import CardKeyList from "./sections/CardKeyList";
import summaryCommonStore from "@/store/summaryCommon.store";
import summarySrcStore from "@/store/summarySrc.store";
import { message } from 'antd';

export default function SummaryPanel({ isOnlyOriginal = false, fromShare = false }: { isOnlyOriginal?: boolean, fromShare?: boolean }) {
  const [activeKey, setActiveKey] = useState("meetingSummary");
  const summaryStreamLoading = summaryStore(
    (state) => state.summaryStreamLoading
  );
  
  const { meetingSummaryLoading, contentLoading, todoLoading } =
    summaryStreamLoading;
  const chapterLoading = summaryChapterStore((state) => state.chapterLoading);
  const speakerLoading = summarySpeakerStore((state) => state.speakerLoading);
  const summary = summaryStore((state) => state.summary);
  const shareInfo = summaryCommonStore((state) => state.shareInfo);
  const summaryLoading = summaryStore((state) => state.summaryLoading);
  const detailInfo = summarySrcStore((state) => state.detailInfo);

  const loading = shareInfo
    ? !summary?.summaryFinish
    : summaryLoading || !detailInfo;

  const cardKeyList = [
    "meetingSummary",
    "meetingContent",
    "todo",
    "chapter",
    "speakerSummary",
  ];
  const verticalAnchorListRef = useRef<VerticalAnchorListRef>(null);

  const onActiveKeyChange = (newActiveKey: string) => {
    setActiveKey(newActiveKey);
  };

  const onSummaryClick = () => {
    message.warning(fromShare ? "请保存后，前往电脑端体验该功能" : "请前往电脑端体验该功能");
  };

  return (
    <>
      {isOnlyOriginal ? (
        <SummaryEmpty onSummaryClick={onSummaryClick} />
      ) : (
        <>
          <VerticalAnchorList
            ref={verticalAnchorListRef}
            onChange={onActiveKeyChange}
          >
            <VerticalAnchorItem data-key="meetingSummary" className="pt-4">
              <Card title="会议概要">
                {meetingSummaryLoading || loading ? (
                  <SummarySkeleton className="mt-4" />
                ) : (
                  <MeetingSummary />
                )}
              </Card>
            </VerticalAnchorItem>

            <VerticalAnchorItem data-key="meetingContent" className="pt-4">
              <Card title="会议内容">
                {contentLoading || loading ? (
                  <>
                    <SummarySkeleton className="mt-4" line={5} />
                    <SummarySkeleton className="mt-4" line={5} />
                  </>
                ) : (
                  <MeetingContent />
                )}
              </Card>
            </VerticalAnchorItem>

            <VerticalAnchorItem data-key="todo" className="pt-4">
              <Card title="会议待办">
                {todoLoading || loading ? (
                  <>
                    <SummarySkeleton className="mt-4" />
                    <SummarySkeleton className="mt-4" />
                  </>
                ) : (
                  <Todo />
                )}
              </Card>
            </VerticalAnchorItem>

            <VerticalAnchorItem data-key="chapter" className="pt-4">
              <Card title="章节速览">
                {chapterLoading ? (
                  <>
                    <SummarySkeleton className="mt-4" line={5} />
                    <SummarySkeleton className="mt-4" line={5} />
                  </>
                ) : (
                  <Chapter />
                )}
              </Card>
            </VerticalAnchorItem>

            <VerticalAnchorItem data-key="speakerSummary" className="py-4">
              <Card title="发言人观点">
                {speakerLoading ? (
                  <>
                    <SummarySkeleton className="mt-4" />
                    <SummarySkeleton className="mt-6" />
                  </>
                ) : (
                  <div className="mt-6">
                    <SpeakerSummary />
                  </div>
                )}
              </Card>
            </VerticalAnchorItem>
          </VerticalAnchorList>
          <CardKeyList
            cardKeyList={cardKeyList}
            activeKey={activeKey}
            scrollToCard={verticalAnchorListRef.current?.scrollToCard}
          />
        </>
      )}
    </>
  );
}
